import React from 'react'

import classnames from 'classnames'

import { Icon } from '~/components/atoms/Icon/Icon'
import Image, { urlFor } from '~/components/atoms/Image/Image'
import Text, { TextSizes } from '~/components/atoms/Text/Text'
import { ComponentTheme } from '~/components/themes'
import truncateString from '~/utils/truncateString'

import type { Video } from '../VideoSlider'

import styles from './VideoArticlePreview.module.css'

export interface VideoArticlePreviewProps extends Video {
  theme?: ComponentTheme
}

export default function VideoArticlePreview({
  title,
  summary,
  coverImage,
  watchTime,
  theme,
  videoUrl,
}: VideoArticlePreviewProps) {
  const image = coverImage && urlFor(coverImage, 1000)

  const goToYouTube = () => {
    const newWindow = window.open(videoUrl, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }

  return (
    <div className={styles.base} onClick={() => goToYouTube()}>
      <div className={styles.imageContainer}>
        {image && (
          <div className={classnames(styles.mediaImageContainer)}>
            <Image
              asset={image}
              objectFit="cover"
              alt={title ? title : undefined}
            />
          </div>
        )}
        <span className={styles.playCircle}>
          <Icon
            type="PlayCircle"
            fill={theme === ComponentTheme.black ? 'black' : 'white'}
          />
          {watchTime && (
            <Text size={TextSizes.primaryTitleSml} className={styles.watchTime}>
              {watchTime}
            </Text>
          )}
        </span>
      </div>
      <div className={styles.contentContainer}>
        <Text size={TextSizes.primaryTitleMed} className={styles.title}>
          {title}
        </Text>
        {summary && (
          <Text size={TextSizes.bodyMed} className={styles.summary}>
            {truncateString(summary, 150)}
          </Text>
        )}
      </div>
    </div>
  )
}
